import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaFileImport,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import { IoMdArrowDroprightCircle } from "react-icons/io";
import { TagComponent } from "../Tabs";

const ExportExcelData = () => {
  const [activeTab1, setActiveTab1] = useState("web");
  const [activeTab2, setActiveTab2] = useState("web");
  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];
  const content1 = {
    web: "",
    mobile: "",
  };
  const content2 = {
    web: "",
    mobile: "",
  };

  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );


  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaFileImport className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color"> Importing Excel Data</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>


      <p className="text-start mb-6 text-gray-600 ">
        You can upload Excel data either while setting up your ‘Seller’ account
        or later from the ‘Products’ section once setup is finished. In both
        cases, download the Excel template from Selzor based on the product
        attributes you’ve chosen.
      </p>

      <div className=" mx-auto bg-white p-6 rounded shadow">
        <div className="m-2 bg-yellow-100 text-yellow-800 p-3 rounded text-start">
          When you change the order of attributes, the Excel template for
          importing data also updates. Each time you reorder attributes, be sure
          to download a new Excel template for product import. You can get the
          template from the ‘Products’ section by clicking the ‘Download
          Template’ button.
        </div>
      </div>

      <div className=" mx-auto bg-gray-100 p-6 rounded shadow">
        {/* Process Title */}
        <p className="text-gray-700 mb-2 text-start font-semibold">
          The process to import Excel data includes the following steps
        </p>

        {/* Steps List */}
        <ul className="border border-gray-200 rounded bg-white mb-4">
          {[
            "Download Latest Excel Template",
            "Fill in the data",
            "Browse & select the Excel file from the Selzor Web App",
            "If any errors are present in your Excel file, the app highlights those errors",
            "Click import to add data to Selzor Server.",
          ].map((step, index) => (
            <li
              key={index}
              className="p-3 text-gray-700 hover:bg-gray-50 text-start flex gap-3"
            >
              <IoMdArrowDroprightCircle className="mt-1" /> {step}
            </li>
          ))}
        </ul>

        {/* Red Warning Box */}
      </div>

      <div className="bg-red-100 border border-red-300 text-red-800 p-3 rounded mb-4">
        Do not change the column order in the downloaded Excel template and do
        not remove the header row. Ensure each product attribute matches the
        required cell type (Text or Number) and stays within the maximum
        character limit. If the limit is exceeded, the app will automatically
        trim the extra characters in each cell.
      </div>

      {/* Yellow Limit Info Box */}
      <div className="bg-yellow-100 border border-yellow-300 text-yellow-800 p-3 rounded">
        You can import up to 1,000 rows of Excel data at a time. If your file
        has more than 1,000 rows, only the first 1,000 rows from Sheet 1 will be
        imported. Any other sheets in the Excel file will be ignored.
      </div>

      <div className="my-5">
        {renderTabs(activeTab1, setActiveTab1)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={content1[activeTab1]}
            alt={`${activeTab1} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
        <div className="mx-4  text-gray-600 p-3 font-semibold rounded text-start ">
          When you upload your Excel file, the Selzor Web App highlights any
          errors in red if the data doesn’t meet Selzor standards. The app also
          automatically creates unique Codes, Categories, Warehouses, Tax Tiers,
          and more, displaying them on the left side.
        </div>
      </div>

      <div className="text-start my-4">
        <h3 className="text-2xl text-gray-500 font-semibold mb-2">
          {" "}
          Data Mapping (Merging New Data with Existing Data)
        </h3>
        <p className="text-gray-400 mb-6">
          When importing Excel data from the ‘Products’ section, an extra dialog
          appears allowing you to map new data to existing entries. This data
          mapping lets you add new information for any category, warehouse, or
          tax tier you’ve previously defined—either in an earlier import or
          otherwise—and merge it with the existing records.
        </p>
      </div>

      {renderTabs(activeTab2, setActiveTab2)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={content2[activeTab2]}
          alt={`${activeTab2} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>

      <div className="mt-4 bg-red-100 text-red-600 p-3 rounded text-start">
        Data mapping is not supported for the product attribute ‘Code’. If a
        product or article code already exists in Selzor and you want to add
        more variations for that ‘Code’, you must manually update it by editing
        the existing entry in the ‘Products’ section. If you re-import that same
        ‘Code’ through Excel, the app will create duplicate entries—keeping the
        old variations under the original ‘Code’ and placing the new variations
        under a newly created ‘Code’.
      </div>
    </div>
  );
};

export default ExportExcelData;
